import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { graphql } from "gatsby";
import { DiscussionEmbed } from "disqus-react";
import CalendarIcon from "../../icons/calendar.svg";
import PenIcon from "../../icons/pen.svg";
import capitalize from "../utils/capitalize";

const PostFull = ({ data }) => {
  const slug = data.markdownRemark.frontmatter.slug;
  const disqusConfig = {
    shortname: process.env.GATSBY_DISQUS_NAME,
    config: {
      identifier: slug,
    },
  };

  let series = ``;
  if (
    data.markdownRemark.frontmatter.series !== undefined &&
    data.markdownRemark.frontmatter.series !== null
  ) {
    series = ` (Serie ${capitalize(
      data.markdownRemark.frontmatter.series
    )} - Parte ${data.markdownRemark.frontmatter.seriesNumber})`;
  }

  return (
    <Layout>
      <SEO
        title={data.markdownRemark.frontmatter.title}
        description={data.markdownRemark.frontmatter.summary}
        imageSource={data.markdownRemark.frontmatter.image.publicURL}
      />

      <h1>
        {data.markdownRemark.frontmatter.title}
        {series}
      </h1>
      <p className="autor-date">
        <PenIcon className="autor-date-icon" />
        {data.markdownRemark.frontmatter.author} |{" "}
        <CalendarIcon className="autor-date-icon" />{" "}
        {capitalize(data.markdownRemark.frontmatter.date)}
      </p>
      <hr />
      <div
        className="post-full-content"
        dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }}
      ></div>
      <hr />
      <div>
        <DiscussionEmbed {...disqusConfig} />
      </div>
    </Layout>
  );
};

export default PostFull;

export const postQuery = graphql`
  query findPost($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      frontmatter {
        author
        date(formatString: "MMMM DD, YYYY", locale: "es-ES")
        slug
        title
        summary
        series
        seriesNumber
        image {
          extension
          publicURL
        }
      }
      html
    }
  }
`;
